(function() {
  var root = document.querySelector('[data-ghost-footer-legal]');
  if (!root) return;

  var modals = root.querySelectorAll('[data-ghost-legal-modal]');
  var openButtons = document.querySelectorAll('[data-ghost-legal-open]');
  var lastFocus = null;
  var activeModal = null;

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function(node) {
      return !node.hidden && node.getAttribute('aria-hidden') !== 'true';
    });
  }

  function closeModal() {
    if (!activeModal) return;

    activeModal.hidden = true;
    activeModal.setAttribute('aria-hidden', 'true');
    activeModal.classList.remove('is-open');
    document.documentElement.style.overflow = '';

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }

    lastFocus = null;
    activeModal = null;
  }

  function openModal(name) {
    var modal = root.querySelector('[data-ghost-legal-modal="' + name + '"]');
    if (!modal) return;

    closeModal();

    lastFocus = document.activeElement;
    activeModal = modal;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(function() {
      modal.classList.add('is-open');
    });

    var closeButton = modal.querySelector('[data-ghost-legal-close]');
    if (closeButton) closeButton.focus();
  }

  openButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      openModal(button.getAttribute('data-ghost-legal-open'));
    });
  });

  root.addEventListener('click', function(event) {
    if (event.target.closest('[data-ghost-legal-close]')) {
      closeModal();
    }
  });

  modals.forEach(function(modal) {
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        closeModal();
      }
    });
  });

  document.addEventListener('keydown', function(event) {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    var panel = activeModal.querySelector('.ghost-legal-modal__panel');
    if (!panel) return;

    var focusables = getFocusable(panel);
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
